import bagDailyImg1 from '../../assets/img/home/Rectangle_28.png';
import bagDailyImg2 from '../../assets/img/home/Rectangle_29.png';
import bagDailyImg3 from '../../assets/img/home/Rectangle_30.png';

export const listBagInDaily = [
    {
        img: bagDailyImg1,
        title: 'It is a long established fact that a reader will be distracted',
        date: 'OCT 15, 2020',
    },
    {
        img: bagDailyImg2,
        title: 'It is a long established fact that a',
        date: 'OCT 15, 2020',
    },
    {
        img: bagDailyImg3,
        title: 'It is a long established fact that a reader will be distracted',
        date: 'OCT 15, 2020',
    },
];
